import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Styles } from 'jss';
import { Colors, Theme } from '@app/theme';
import { Button } from '../Buttons';
import { ButtonProps } from './Button';
import mapValues from 'lodash/mapValues';
import { Feature } from '@app/api';
import { LockFeatureChip } from '../LockFeatureChip';

const useStyles = createUseStyles((theme: Theme) => ({
  icon: {
    fontSize: 20,
    marginRight: theme.marginBase * 2,
  },
  chip: {
    marginRight: theme.marginBase * 2,
  },
  button: {
    textAlign: 'left',
    justifyContent: 'flex-start',
  },
}));

const useColorsStyle = createUseStyles((theme: Theme): Styles<Colors> => {
  return mapValues(theme.colorDefinitions, (def) => ({
    color: def.std,
  }));
});

interface Props {
  text?: string;
  icon: string;
  iconColor: Colors;
  lockOnFeature?: Feature;
  // Useful when locking enabled
  planId?: string;
}

export type IconMutedButtonProps = Props & ButtonProps;

export const IconMutedButton = ({
  text,
  children,
  icon,
  iconColor,
  contentClassName,
  ...props
}: IconMutedButtonProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const colorClasses: any = useColorsStyle({ theme });
  return (
    <Button
      type="button"
      color="ink"
      variant="muted"
      contentClassName={classnames(classes.button, contentClassName)}
      {...props}
    >
      <LockFeatureChip
        className={classes.chip}
        feature={props.lockOnFeature}
        planId={props.planId}
      >
        <i
          className={classnames(classes.icon, colorClasses[iconColor], icon)}
        />
      </LockFeatureChip>
      {text}
      {children}
    </Button>
  );
};
